<template>
<div>
    <!-- modal -->
    <b-modal id="previewKktcEInvoiceFormModal" centered size="xl" no-close-on-backdrop ref="previewKktcEInvoiceFormModal" :title=" $t('previewEInvoice.preview_e_invoice')" hide-footer>
        <div class="custom-search mb-1">
                <b-row>
                    <b-col class="col-lg-4 mt-1">
                        <label for="invoice-add-item-date-input">{{ $t('previewEInvoice.invoice_date') }}</label>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" id="invoiceDate" v-model="eInvoiceDate"  @input="updatekktcEInvoiceInfo()" :defaultDate="null" reset-button class="mb-1" size="sm" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-col>
                    <b-col class="col-lg-4 mt-1">
                        <label for="invoice-add-item-name-input">{{ $t('previewEInvoice.invoice_no') }}</label>
                        <b-form-input id="invoice-add-item-name-input" v-model="invoiceNo" type="number" maxlength="10" @input="updatekktcEInvoiceInfo()" size="sm"/>
                    </b-col>
                    <b-col class="col-4 d-flex justify-content-end">
                        <b-button variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('others.show_invoice')" @click="CreateFaturaForSend()">
                            <feather-icon icon="FileTextIcon" size="10" class="align-middle" />
                        </b-button>
                    </b-col>
                </b-row>
        </div>
        <div v-html="html" >
        </div>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getCreateKktcInvoiceList: {
            type: Function
        }
    },   
    data() {
        return {
            id:0,
            html:'',
            eInvoiceDate: null,
            invoiceNo:0
        }
    },
    methods: {
        CreateFaturaForSend() {
            const data = {
                id: this.id,
            }
            const controller = {
                name: 'Invoice',
                actionName: 'CreateKktcInvoice'
            }
            const payload = {
                data: data,
                controller: controller
            }

            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(response.data.document.name, response.data.base64, response.data.document.type)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        updatekktcEInvoiceInfo(){
            const data = {
                id: this.id,
                einvoiceDate: this.eInvoiceDate,
                invoiceNo: this.invoiceNo
            }

            const controller = {
                name: 'Invoice',
                actionName: 'UpdatekktcEInvoiceInfo'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.showInfo(this.id)
                    this.getCreateKktcInvoiceList()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        showInfo(id) {
            this.$refs['previewKktcEInvoiceFormModal'].show()
            this.id = id
            
            let data = {
                id : this.id
            }
            let controller = {
                name: 'Invoice',
                actionName: 'PreviewKktcEInvoiceInfo'
            }
            let payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.eInvoiceDate = response.data.eInvoice.eInvoiceDate,
                    this.invoiceNo = response.data.eInvoice.invoiceNo                                       
                } else {
                    this.$WarningAlert("Hata Oluştu")                    
                }
                loader.hide()
            })
        }

    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
